// 采购单

import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useInquiryModel } from "../inquiryModel";
import { inquiryStatusOption } from "@/types/supplierDs";


export function PageHeader() {
    
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useInquiryModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "询价单号",
            fieldName: "inquiryCode",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "供应商名称",
            fieldName: "supplierName",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "单据状态",
            fieldName: "status",
            options: inquiryStatusOption
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["起始日期", "结束日期"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
        
    ]

    return (
        <>
            <YhPageHeader
                title="询价单列表"
                size="small"
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                triggerSearch
                handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
                handleReset={resetSearchParam}
            />
        </>
    );
}